export { RLogo as default } from './RLogo';
